module.exports = __webpack_public_path__ + "img/image 37@2x.3f5679e1.png";